import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="newsLike";
export function clickNewsLike(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function selectByNewsId(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectByNewsId/${parameter}`,
    method: 'get',
  })
}

export default {
  clickNewsLike,
  selectByNewsId,
}